/* MTD Sticky add to cart — mirrors the buy box tier, submits the buy box form. */
(function () {
  'use strict';

  function init(bar) {
    if (bar.dataset.mtdReady === 'true') return;
    bar.dataset.mtdReady = 'true';

    var buybox = document.querySelector('[data-mtd-buybox]');
    var form = document.getElementById('mtd-buybox-form');
    var button = bar.querySelector('[data-mtd-sticky-add]');
    var priceEl = bar.querySelector('[data-mtd-sticky-price]');
    var compareEl = bar.querySelector('[data-mtd-sticky-compare]');

    bar.hidden = false;

    /* Show once the buy box has scrolled out of view. */
    if (buybox && 'IntersectionObserver' in window) {
      var anchor = buybox.querySelector('[data-mtd-add]') || buybox;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      }, { rootMargin: '0px 0px -100% 0px' }).observe(anchor);
    } else {
      bar.classList.add('is-visible');
    }

    /* Mirror the selected tier's pricing. */
    document.addEventListener('mtd:tier:change', function (event) {
      var d = event.detail || {};
      if (priceEl && d.price) priceEl.textContent = d.price.trim();
      if (compareEl) {
        var compare = (d.compare || '').trim();
        compareEl.textContent = compare;
        compareEl.hidden = !compare;
      }
    });

    /* Reuse the buy box form so bundle, subscription and discount logic all apply. */
    if (button) {
      button.addEventListener('click', function () {
        if (!form) return;
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit(form.querySelector('[data-mtd-add]') || undefined);
        } else {
          form.submit();
        }
      });
    }
  }

  function boot() { document.querySelectorAll('[data-mtd-sticky]').forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else { boot(); }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-mtd-sticky]').forEach(init);
  });
})();
